import { RootState } from '../..';
import { NotificationData, PriceNotificationsData } from './types';

export const selectNotifications = (state: RootState): NotificationData[] => state.user.notifications.notifications;
export const selectNotificationsLoading = (state: RootState): boolean => state.user.notifications.loading;
export const selectSetNotification = (state: RootState): boolean => state.user.notifications.setPriceNotificationLoading;
export const selectPriceNotifications = (state: RootState): PriceNotificationsData[] => state.user.notifications.priceNotifications;
export const selectPriceNotificationsLoading = (state: RootState): boolean => state.user.notifications.priceNotificationLoading;
